export function mySlideUp(elm) {
	if (elm.classList.contains('active')) {
		elm.style.height = '0px';
		elm.addEventListener('transitionend', function () {
			elm.classList.remove('active');
		}, {
			once: true
		});
	}
}